module.exports = __webpack_public_path__ + "img/help_black_24dp.533e3196.svg";